<template>
  <div class="formhead p-3 my-2">
    <form v-on:submit.prevent="enviaForm" tyle="color:#0836a9">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="nombre">Nombre (s)</label>
            <input type="text" class="form-control" id="nombre" v-model="formInteres.nombre" placeholder="Nombre"
              required />
          </div>
          <div class="form-group">
            <label for="email">E-mail</label>
            <input type="email" class="form-control" id="email" v-model="formInteres.email"
              placeholder="correo@electronico.com" required />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="apellido">Apellido Paterno</label>
            <input type="text" class="form-control" id="apellido" v-model="formInteres.apellido"
              placeholder="Apellido Paterno" required />
          </div>
          <div class="form-group">
            <label for="movil">Télefono Móvil</label>
            <input type="text" class="form-control" id="movil" v-model="formInteres.movil" placeholder="00 1122 3344"
              required />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="plantel">Plantel</label>
            <select class="form-control" id="plantel" v-model="formInteres.plantel" required>
              <option value="">Elije uno</option>
              <option>Montevideo</option>
              <option>Tlalpan</option>
              <option>Tláhuac</option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="interes">Interés</label>
            <select class="form-control" id="interes" v-model="formInteres.interes" required>
              <option value="">Elije uno</option>
              <optgroup label="Cursos">
                <option v-for="cursos in cursos" v-bind:key="cursos.id">{{ cursos.text }}
                </option>
              </optgroup>
              <optgroup label="Diplomados">
                <option :selected="ruta == 'acompannamientoPsicologicoCrianzaNinnez'">Diplomado Acompañamiento Psicológico en la Crianza y Desarrollo en la Niñez</option>
                <option :selected="ruta == 'capitalHumano'">Diplomado Capital Humano (RRHH)</option>
                <option :selected="ruta == 'derechoCorporativo'">Diplomado Derecho Corporativo</option>
                <!--option :selected="ruta == 'desarrolloOrganizacionalChangeManagement'">Diplomado Desarrollo Organizacional: Conducta y Change Management</option-->
                <option :selected="ruta == 'desarrolloOrganizacionalGestionCambio'">Diplomado Desarrollo Organizacional y Gestión del Cambio</option>
                <!--option :selected="ruta == 'escenaCrimenAnalisisForense'">Diplomado Escena del Crimen y Análisis Forense</option-->
                <!--option :selected="ruta == 'EspiritualidadSanacionReligion'">Diplomado Espiritualidad, religión y sanación</option-->
                <!--option :selected="ruta == 'gestionEmpresarialEmprendimiento'">Diplomado Gestión Empresarial - Emprendimiento 360°</option-->
                <option :selected="ruta == 'Hipnosis'">Diplomado Hipnosis</option>
                <!--option :selected="ruta == 'Juicios'">Diplomado Juicios Orales en materia penal</option-->
                <option :selected="ruta == 'juiciosAmparo'">Diplomado Juicios de Amparo</option>
                <option :selected="ruta == 'meditacionEnfoqueTranspersonal'">Diplomado Meditación con EnfoqueTranspersonal</option>
                <option :selected="ruta == 'pruebasPsico'">Diplomado Pruebas Psicológicas</option>
                <option :selected="ruta == 'comunicacionNoVerbal'">Diplomado Psicología de la verdad, Comunicación no verbal...</option>
                <option :selected="ruta == 'psicologiaJuridica'">Diplomado Psicología Jurídica, Forense y Perfilación Criminológica</option>
                <option :selected="ruta == 'Psicopatologia'">Diplomado Psicopatología</option>
                <option :selected="ruta == 'Ptransin'">Diplomado Psicoterapia Transpersonal</option>
                <!--option :selected="ruta == 'Tanatologiatrans'">Diplomado Tanatologia Transpersonal</option-->
                <option :selected="ruta == 'Terajuegos'">Diplomado Terapia de Juego</option>
                <option :selected="ruta == 'Terapareja'">Diplomado Terapia de Pareja y Sexualidad</option>
                <option :selected="ruta == 'terapiaFamiliar'">Diplomado Terapia Familiar</option>
                <option :selected="ruta == 'tecnicasEstrategiasNeurociencia'">Diplomado Técnicas y Estrategias de Psicoterapéuticas de Neurociencia</option>
                <option :selected="ruta == 'trabajoSocialHerramientas'">Diplomado Trabajo Social y sus Herramientas</option>
                <!--option :selected="ruta == 'transformacionDigitalIA'">Diplomado Transformación Digital + IA</option-->
                <option :selected="ruta == 'transtornodeficit'">Diplomado Trastornos por Déficit de atención e hiperactividad</option>
                <option :selected="ruta == 'habilidadesclinicas'">Diplomado Habilidades Clínicas</option>
              </optgroup>
              <optgroup label="Talleres">
                <option :selected="ruta == 'aprendiendoperdonar'">Taller Aprendiendo a Perdonar</option>
                <option :selected="ruta == 'autoestima'">Taller Autoestima</option>
                <!--option :selected="ruta == 'codependencia'">Taller Codependencia</option-->
                <option :selected="ruta == 'construyendoAnnoProposito'">Taller Construyendo el Año con Propósito</option>
                <option :selected="ruta == 'delDerechoAdministracion'">Taller Del Derecho a la Administración</option>
                <option :selected="ruta == 'duelo'">Taller Duelo</option>
                <option :selected="ruta == 'cuentoRecursoSocioemocional'">Taller el Cuento como Recurso Socioemocional</option>
                <option :selected="ruta == 'entreSaludLey'">Taller Entre la Salud y la Ley</option>
                <!--option :selected="ruta == 'explorandoSexualidad'">Taller Explorando mi Sexualidad</option-->
                <option :selected="ruta == 'heridasNacimiento'">Taller Sanando Heridas de Nacimiento</option>
                <option :selected="ruta == 'iniciandoAnnoSignificado'">Taller Iniciando tu Año con Significado</option>
                <option :selected="ruta == 'inteligenciaEmocional'">Taller Inteligencia Emocional para la Vida</option>
                <option :selected="ruta == 'morirDerecho'">Taller ¿Morir es un Derecho?</option>
                <option :selected="ruta == 'neurodiversidadInclusion'">Taller Neurodiversidad e Inclusión</option>
                <option :selected="ruta == 'nuevoProcesoCivilFamiliar'">Taller Nuevo Proceso Civil y Familiar</option>
                <option :selected="ruta == 'ponerLimites'">Taller ¿Porqué nos Cuesta Trabajo Poner Límites?</option>
                <option :selected="ruta == 'renacerDespuesAdversidad'">Taller Renacer Después de la Adversidad</option>
                <option :selected="ruta == 'inmersionSonora'">Sesión de Inmersión Sonora</option>
                <option :selected="ruta == 'transformarDolorSignificado'">Taller Transformar el Dolor en Significado</option>
                <!--option :selected="ruta == 'repasoNeuroanatomia'">Taller Un Repaso a la Neuroanatomía</option-->
                <option :selected="ruta == 'viviendo'">Taller Viviendo mi Propia Muerte</option>
                <option :selected="ruta == 'amorCodependencia'">Taller ¿Amor o Codependencia?</option>
              </optgroup>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="medio">¿Por qué medio te enteraste de nosotros?</label>
            <select class="form-control" id="medio" v-model="formInteres.medio" required>
              <option value="">Elije uno</option>
              <option>Cartel</option>
              <option>Folleto</option>
              <option>Manta</option>
              <option>Radio</option>
              <option>Automóvil</option>
              <option>Fachada</option>
              <option>Página de internet</option>
              <option>Correo electrónico</option>
              <option>Facebook</option>
              <option>You Tube</option>
              <option>Twitter</option>
              <option>Google +</option>
              <option>Instagram</option>
              <option>Waze</option>
              <option>Otro</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="asunto">Asunto</label>
            <input type="text" class="form-control" id="asunto" v-model="formInteres.asunto"
              placeholder="asunto/mensaje" required />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="aviso" checked required />
            <label class="form-check-label" for="aviso">
              Al hacer click en "Enviar", reconoces haber leído las Políticas de
              nuestro
              <a href="https://centrodetanatologia.com/pdf/Aviso_de_Privacidad_CTTD.pdf"
                style="color:#D9272E; font-weight:bold;" target="_blank">Aviso de Privacidad</a>
              y autorizas estar de acuerdo con el uso de ellas, así como con los
              Términos y Condiciones del sitio.
            </label>
          </div>
        </div>
      </div>
      <div class="text-center">
        <button type="submit" class="btn btn-primary">ENVIAR</button>
      </div>
    </form>
  </div>
</template>
<script>
import axios from "axios";
export default {
  mounted() { },
  data() {
    return {
      formInteres: {
        nombre: "",
        email: "",
        apellido: "",
        movil: "",
        plantel: "",
        interes: "",
        medio: "",
        asunto: ""
      },
      ruta: this.$router.currentRoute.name,
      selected: null,
      cursos: [
        //{ text: "Examinación del Estado Mental", sel: "" },
        { text: "Integración Psicosocial Integrativa", sel: "" },
        { text: "Inteligencia Emocional Aplicada", sel: "" },
        { text: "Lenguaje de Señas Mexicanas", sel: "" },
        //{ text: "Sanando mi Árbol Genealógico", sel: "" },
        //{ text: "Psicología de Rostro y Cuerpo", sel: "" },
        { text: "Enfermería", sel: "" },
        { text: "Técnicas de Intervención Tanatológica", sel: "" },
      ]
    };
  },
  created() { },
  methods: {
    enviaForm() {
      console.log(this.formInteres);
      var params = "json=" + JSON.stringify(this.formInteres);
      axios
        .post('https://centrodetanatologia.com/enviaemail/savemailSecciones.php', params)
        .then(respuesta => {
          console.log(respuesta);
          if (respuesta.data.status == "exito") {
            alert(
              "Gracias - Mensaje enviado \n\n Nos pondremos en contacto lo antes posible."
            );
            window.location.href = window.location.href;
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/forms/FormularioSecciones.vue